var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-to-top'),(_vm.eleTokenWrd001)?[_c('head-nav')]:[_c('Header')],(_vm.plates.length>0)?_c('router-view',{key:Math.random(),attrs:{"plates":_vm.plates}}):_vm._e(),_c('footer-nav')],2)}
var staticRenderFns = []

export { render, staticRenderFns }